import { render, staticRenderFns } from "./GameKeys.vue?vue&type=template&id=61e97be0&"
import script from "./GameKeys.vue?vue&type=script&lang=js&"
export * from "./GameKeys.vue?vue&type=script&lang=js&"
import style0 from "./GameKeys.vue?vue&type=style&index=0&id=61e97be0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports